import { constants } from "@newsela/angelou";

const { colors } = constants;
const coreBlue = colors.ui.core[25];
const grey = colors.ui.neutral[600];

export const promptContainerCss = {
  background: coreBlue,
  borderRadius: "8px",
  color: grey,
  lineHeight: 1.5,
  padding: "12px 12px 12px 16px",
  wordBreak: "break-word",
};
